import { createContext } from "react";
import { IMillOnboardingContext } from "./MillOnboardingContextInterfaces";
import { isCorporateOnboarding } from "utilities/storageUtilities";

export const initialState: IMillOnboardingContext = {
    isMillOnboarding: Boolean(isCorporateOnboarding()),
    isOnboardingFetch: async () => {},
};

export const MillOnboardingContext = createContext(initialState);
